// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__26LVa","dragIcon":"SortableItem_dragIcon__1XfJD","disabled":"SortableItem_disabled__29wVE"};